<template>
  <v-container
    id="login"
    class="fill-height justify-center"
    tag="section"
  >
    <v-row justify="center">
      <v-slide-y-transition appear>
        <base-material-card
          color="primary"
          light
          max-width="100%"
          width="600"
          class="px-5 py-3"
        >
          <template v-slot:heading>
            <div class="text-center">
              <v-row
                align="center"
                justify="center"
              >
                <v-col cols="5">
                  <v-img :src="require('../../assets/train.png')" />
                </v-col>
                <v-col cols="7">
                  <h1 class="display-3 font-weight-bold">
                    LOGIN
                  </h1>
                </v-col>
              </v-row>
            </div>
          </template>
          <v-card-text>
            <v-alert
              color="red"
              dark
              v-if="error"
            >
              {{ error }}
            </v-alert>
            <v-form
              v-model="valid"
              ref="form"
            >
              <text-field
                label="Email or LDAP username"
                v-model="username"
                prepend-icon="mdi-email"
                :rules="[rules.required]"
                v-on:keyup.enter="login"
                autofocus
                :readonly="loading"
              />

              <text-field
                class="mb-8"
                type="password"
                label="Password"
                v-model="password"
                prepend-icon="mdi-lock-outline"
                :rules="[rules.required]"
                v-on:keyup.enter="login"
                :readonly="loading"
              />
            </v-form>
            <v-btn
              color="primary"
              @click="login"
              :loading="loading"
            >
              Login
            </v-btn>
          </v-card-text>
        </base-material-card>
      </v-slide-y-transition>
    </v-row>
  </v-container>
</template>

<script>
  import UserService from '@/services/user'
  import TextField from '@/components/TextField'
  import Validation from '@/mixins/Validation'

  export default {
    name: 'Login',
    mixins: [
      Validation,
    ],
    components: { TextField },
    data: () => ({
      valid: false,
      loading: false,
      username: null,
      password: null,
      error: null,
      rules: {
        required: value => !!value || 'Required.',
      },
    }),
    methods: {
      login () {
        this.validate()
        if (this.valid) {
          this.loading = true
          this.error = null
          const us = new UserService()
          us.login(this.username, this.password).then((response) => {
            this.$router.push('/')
          }, () => {
            this.error = 'Wrong username or password.'
          }).finally(() => {
            this.loading = false
          })
        }
      },
    },
  }
</script>
